/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  class BundleRemove extends HTMLElement {
    constructor() {
      super();
    }
    removeBundle(){
      this.cartItem.classList.add('is-removed');
      let updates = {};
      this.components.forEach(component => {
        const key = component.getAttribute('data-component-key');
        if(key) {
          updates[key] = 0;
        }
      });

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        this.cart?.getCart();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    connectedCallback() {
      this.cart = this.closest('cart-element');
      this.cartItem = this.closest('[data-cart-item]');
      this.bundleId = this.cartItem?.dataset?.bundleId;
      this.free_component = this.cart.querySelector(`[data-free][data-bundle-id="${this.bundleId}"]`);
      this.components = Array.from(this.cartItem?.querySelectorAll('[data-component]'));
      if(this.free_component) {
        this.components.push(this.free_component);
      }
      if (this.components) {
        this.addEventListener('click', this.removeBundle.bind(this)); 
      }
    }
  }
  if (!customElements.get('bundle-remove')) {
    customElements.define('bundle-remove', BundleRemove);
  }
  /* refresh cart if the page was loaded from cache */
  window.addEventListener("pageshow", (event) => {
    if (event.persisted || window.performance?.getEntriesByType("navigation")?.[0]?.type === 'back_forward'){
      console.log('refresh cart because it was loaded from client cache!');
      document.querySelector('cart-element')?.getCart(false);
    }
  })
})();
